//* Components
import Logo from 'components/common/Logo';
import Image from 'components/common/Image';
import Text from 'components/common/Text';

//* Style
import LandingHeaderStyle from './style';

const LandingHeader = ({ title, image, full_type }) => {
	return (
		<LandingHeaderStyle>
			<Image
				objectFit={'cover'}
				src={image.url}
				alt={image.alt}
				className={'hero-image'}
			/>

			<div className='layer' />

			<div className='layer-2' />

			<Logo className='landing-header-logo' />

			<Text
				className={`h1 font-soundscape-bold primaryColor3 title ${full_type ? 'full-version' : ''}`}
				text={title}
			/>
		</LandingHeaderStyle>
	);
};

export default LandingHeader;
